/* global document */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import GoogleMap from '../GoogleMap/GoogleMap'
import FullSlider from '../Slider/FullSlider'
import setValue from '../../../shared/actions/setValue'
import { hideBodyScroll, showBodyScroll } from '../../../search/utils'


class FullMap extends React.PureComponent {
  static propTypes = {
    setOwnValue: PropTypes.func.isRequired,
    results: PropTypes.arrayOf(PropTypes.object),
    fullMap: PropTypes.bool,
    browser: PropTypes.objectOf(Object).isRequired,
    isDestination: PropTypes.bool,
    isOffers: PropTypes.bool,
  }

  static defaultProps = {
    results: [],
    fullMap: false,
    isDestination: false,
    isOffers: false,
  }

  state = {
    selectedSliderItem: null,
  }

  componentDidMount() {
    document.addEventListener('keyup', this.onKeyUp, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onKeyUp, false)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {oldFullMap} = prevProps;
    const {fullMap} = this.props;
    if (oldFullMap !== fullMap) {
      // Toggle full map
      this.disablePageScroll(fullMap)
    }
  }

  disablePageScroll = (action) => {
    if (action) {
      hideBodyScroll()
    } else {
      showBodyScroll()
    }
  }

  onKeyUp = (e) => {
    const { setOwnValue } = this.props
    if (e.key === 'Escape') {
      setOwnValue('fullMap', false)
      document.body.style = undefined
    }
  }

  getActiveSlide = () => {
    const { results } = this.props
    let ke = 1
    results.forEach((i, key) => {
      if (i.active === true) {
        ke = key + 1
      }
    })
    return ke
  }

  changeActiveMarker = (id) => {
    this.setState({
      selectedSliderItem: id,
    })
  }

  calculateTopOffset = () => (
    document.querySelector('.site-header').clientHeight
  )

  render() {
    const {
      fullMap,
      results,
      browser: { mediaType },
      isDestination,
      isOffers,
      zoomButton,
      itemComponent,
      zoomOutButton
    } = this.props
    const { selectedSliderItem } = this.state
    return (
      <div style={{
        display: fullMap ? 'block' : 'none',
        position: 'fixed',
        top: this.calculateTopOffset(),
        right: 0,
        left: 0,
        bottom: 0,
        zIndex: 100,
        background: 'white',
      }}
      >
        {fullMap && (
          <GoogleMap
            isDestination={isDestination}
            results={results}
            style={{ height: '100%' }}
            isFullMap
            isOffers={isOffers}
            selectedSliderItem={selectedSliderItem}
            zoomButton={zoomButton}
            zoomOutButton={zoomOutButton}
          />
        )}
        {(fullMap && results.length && itemComponent) ? (
          <FullSlider
            isDestination={isDestination}
            active={this.getActiveSlide()}
            results={results}
            resulution={mediaType}
            itemComponent={itemComponent}
            onSelectSliderItem={this.changeActiveMarker}
          />
        ) : null}
      </div>
    )
  }
}


export default connect(({ main: { fullMap, results }, browser }) => ({
  fullMap,
  results,
  browser,
}), dispatch => ({ setOwnValue: (key, value) => dispatch(setValue(key, value)) }))(FullMap)
